import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space, radii } = theme

export const Title = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  br {
    display: none;
  }

  @media (${media.tablet}) {
    h2,
    span {
      font-size: 3.5rem;
    }

    br {
      display: block;
    }
  }
`

export const Video = styled.div`
  position: relative;
  margin-bottom: ${space['spacing-lg']};
  border-radius: ${radii['corner-radius-md']};
  overflow: hidden;

  @media (${media.tablet}) {
    margin-right: ${space['spacing-lg']};
  }
`
